/*

    Due to changes in material-ui v5 onwards. We can't use JSS anymore, so mui/styled and
    makeStyles doesn't work. An alternative approach I decided to use was styled components on the
    material ui components. Exporting them out instead of the makeStyles invokation.

    There are many schools of thought here, and many approaches. 

    Is this a good approach? Experience will tell. 

    Update: Not a bad approach, but there are better options out there, such as createStyled and ThemeProvider 
*/

import { AppBar, Typography } from '@mui/material';
import styled from 'styled-components';

export const StyledAppBar = styled(AppBar) `

    && {
        border-radius: 15px;
        margin: 30px 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: 0.3s;
    }
`;

// export const StyledTypography = styled(Typography) `

//     && {
//         color: #fff;
//         font-family: 'Comforter';
//     }
// `;

export const flexCentered = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
}

export const flexColumnCentered = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
}

export const flexRowCentered = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
}